import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../hooks/redux';
import { APP_ROUTES } from '../../constants';

const ProtectedRoute = ({ 
  children, 
  redirectPath = APP_ROUTES.LOGIN 
}) => {
  const location = useLocation();
  const { isAuthenticated } = useAppSelector(state => state.auth);
  
  if (!isAuthenticated) {
    return (
      <Navigate 
        to={redirectPath} 
        state={{ from: location.pathname }} 
        replace 
      />
    );
  }
  
  return <>{children}</>;
};

export default ProtectedRoute;